import {
  Container,
  FirstContainer,
  SecondContainer,
  LeftSecondContainer,
  RigthSecondContainer,
  ThirdContainer,
} from "./style";
import { useUser } from "../../../providers/UserContext";
import { useSausage } from "../../../providers/SausageContext";
import { useFries } from "../../../providers/FriesContext";
import { useCutChicken } from "../../../providers/CutChickenContext";
import { useChicken } from "../../../providers/ChickenContext";

const TopShipping = () => {


  const {infoChicken} = useChicken()
  const {infoCutChicken} = useCutChicken()
  const {infoFries} = useFries()
  const {infoSausage} = useSausage()

  function calculatePrecoMedio() {

    const mediaSausage = infoSausage?.estoque * infoSausage?.preco
    const mediaFries = infoFries?.estoque * infoFries?.preco
    const mediaChicken = infoChicken?.estoque * infoChicken?.preco
    const mediaCutChicken = infoCutChicken?.estoque * infoCutChicken?.preco

    return parseFloat((mediaSausage + mediaChicken + mediaCutChicken + mediaFries) / 4).toFixed(2)

  }

  return (
    <Container>
      {/* <FirstContainer>
        <h3>Estoque inicial</h3>
        <p>0</p>
        <small>Kg</small>
      </FirstContainer> */}
      <SecondContainer>
        <LeftSecondContainer>
          <h3>
            <img src="./images/ticket.svg" alt="ticket" />
            Peso
          </h3>
          <p>{infoChicken?.estoque + infoSausage?.estoque + infoCutChicken?.estoque + infoFries?.estoque}</p>
          <small>Kg</small>
        </LeftSecondContainer>
        <RigthSecondContainer>
          <h3>
            Produtos
            <img src="./images/product_recipe.svg" alt="product_recipe" />
          </h3>
          <div>
            <img src="./images/sausage_pcp.svg" alt="sausage_pcp" />
            <small>{infoSausage?.estoque} caixas</small>
          </div>
          <div>
            <img src="./images/chicken_pcp.svg" alt="chicken_pcp" />
            <small>{infoCutChicken?.estoque} caixas</small>
          </div>
          <div>
            <img src="./images/cut_chicken_pcp.svg" alt="cut_chicken_pcp" />
            <small>{infoCutChicken?.estoque} caixas</small>
          </div>
          <div>
            <img src="./images/fries_pcp.svg" alt="sausage_pcp" />
            <small>{infoFries?.estoque} caixas</small>
          </div>
        </RigthSecondContainer>
      </SecondContainer>
      <ThirdContainer>
        <h3>Custo médio</h3>
        <p>
          <img src="./images/cifrao.svg" alt="cifrao" /> R${calculatePrecoMedio()}/Kg
        </p>
        <small>(Custo médio de estoque)</small>
      </ThirdContainer>
    </Container>
  );
};
export default TopShipping;
